/**
 * Shared form input styling.
 *
 * DESIGN.md §6 "Inputs" specifies a bottom-border-only architecture on
 * `surface-container-lowest` with a `primary` focus border. Every text /
 * textarea / select / number input on the ops console must use this
 * constant so the visual signature stays consistent (previously each
 * page re-declared its own copy and drifted over time).
 *
 * Keyboard focus adds a 2px `primary` ring with an offset coloured by
 * the parent surface — DESIGN.md §9 "Focus rings". Default offsets
 * against `surface-container` (the standard card). Modals render on
 * `surface-container-highest`; use the matching variant when nesting
 * inside one.
 */
export const INPUT_CLASS =
  'w-full rounded-lg bg-surface-container-lowest px-3 py-2 text-sm text-on-surface placeholder:text-outline border-0 border-b border-outline-variant focus:border-primary focus:outline-none transition-colors focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 focus-visible:ring-offset-surface-container disabled:opacity-60';

/**
 * Variant used inside modals that render on `surface-container-highest`
 * so the focus ring offset contrasts with the modal backdrop.
 */
export const INPUT_CLASS_ON_HIGHEST =
  'w-full rounded-lg bg-surface-container-lowest px-3 py-2 text-sm text-on-surface placeholder:text-outline border-0 border-b border-outline-variant focus:border-primary focus:outline-none transition-colors focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 focus-visible:ring-offset-surface-container-highest disabled:opacity-60';

/**
 * Monospaced variant for codes / identifiers (gift card codes, account
 * ids, etc.). Same focus / border chrome, differs only in font.
 */
export const INPUT_CLASS_MONO =
  'w-full rounded-lg bg-surface-container-lowest px-3 py-2 text-sm font-mono text-on-surface placeholder:text-outline border-0 border-b border-outline-variant focus:border-primary focus:outline-none transition-colors focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 focus-visible:ring-offset-surface-container disabled:opacity-60';

/**
 * Monospaced + modal variant (e.g. redeem-on-behalf confirmation).
 */
export const INPUT_CLASS_MONO_ON_HIGHEST =
  'w-full rounded-lg bg-surface-container-lowest px-3 py-2 text-sm font-mono text-on-surface placeholder:text-outline border-0 border-b border-outline-variant focus:border-primary focus:outline-none transition-colors focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 focus-visible:ring-offset-surface-container-highest disabled:opacity-60';
